import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Table,
  Alert,
  Form,
  Button,
} from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import axios from "axios";

const AttendanceTransportHistory = () => {
  const { userId, GetstudentData } = useContext(ProductContext);
  const studentId = GetstudentData?.id;
  const StudentSession = GetstudentData?.session;
  const authtoken = localStorage.getItem("token");

 const navigate = useNavigate();
  const { StudentProfileData } = useContext(ProductContext);
  const [secondModalVisible, setSecondModalVisible] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransportAttendance();
  }, []);

  const fetchTransportAttendance = async () => {
    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/attendance/StudentAttendance/single",
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth": authtoken,
          },
        }
      );
      setAttendanceData(response.data);
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log(attendanceData, "attendanceData 1500")

  const getStatusClass = (status) => {
  switch (status?.toLowerCase()) {
    case "present":
      return "bg-success";
    case "absent":
      return "bg-danger";
    case "leave":
      return "bg-warning";
    case "halfday":
      return "bg-dark";
    case "holiday":
      return "bg-info";
    default:
      return "bg-secondary";
  }
};

// Convert flat attendance list into grouped by month & date
// Convert flat attendance list into grouped by month & date
// const groupedData = {};

// attendanceData?.data?.forEach((item) => {
//   const dateObj = new Date(item.date); // e.g. 2024-05-11T00:00:00.000Z
//   const day = dateObj.getUTCDate(); // use UTC to avoid timezone shift
//   const monthName = dateObj.toLocaleString("default", { month: "short" }); // e.g. "May"
  

//   if (!groupedData[day]) groupedData[day] = {};
//   groupedData[day][monthName] = item.status;
// });

// Group data by day + month
const groupedData = {};

attendanceData?.data?.forEach((item) => {
  const [year, month, day] = item.date.split("T")[0].split("-"); // e.g. ["2025", "11", "01"]
  const monthName = new Date(0, parseInt(month, 10) - 1)
    .toLocaleString("default", { month: "short" }); // e.g. "Nov"

  if (!groupedData[day]) groupedData[day] = {};
  groupedData[day][monthName] = item.status;
});

// ✅ Sort days from 01 → 31 (numeric sort)
const sortedDays = Object.keys(groupedData)
  .map((d) => parseInt(d, 10)) // convert "01" → 1
  .sort((a, b) => a - b)        // numeric ascending
  .map((d) => d.toString().padStart(2, "0")); // back to "01", "02", etc.

// Sort days numerically (01, 02, 03, ...)



// const sortedDays = Object.keys(groupedData).sort(
//   (a, b) => parseInt(a) - parseInt(b)
// );


// Compute totals dynamically
const attendanceTotals = {
  present: 0,
  absent: 0,
  leave: 0,
  halfday: 0,
  holiday: 0,
};
attendanceData?.data?.forEach((item) => {
  const status = item.status?.toLowerCase();
  if (attendanceTotals.hasOwnProperty(status)) {
    attendanceTotals[status] += 1;
  }
});




  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "present":
        return "green";
      case "absent":
        return "red";
      case "leave":
        return "orange";
      default:
        return "gray";
    }
  };

 


  return (
    <div className="page-wrapper">
      <Header />
     <div className="tab-content">
  
  <div className="tab-pane fade active show mt-3" id="attendance" role="tabpanel">
    <div className="card">
  <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-1">
    <h4 className="mb-3">Transport Attendance History</h4>
    <div className="d-flex align-items-center flex-wrap">
      <div className="d-flex align-items-center flex-wrap me-3">
        <p className="text-dark mb-3 me-2">
          Last Updated on : {new Date().toLocaleDateString()}
        </p>
        <button
          onClick={fetchTransportAttendance}
          className="btn btn-primary btn-icon btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0 mb-3"
        >
          <i className="ti ti-refresh-dot" />
        </button>
      </div>
    </div>
  </div>

  <div className="card-body pb-1">
    <div className="row">
      {/* Present */}
      <div className="col-md-6 col-xxl-4 d-flex">
        <div className="d-flex align-items-center rounded border p-3 mb-3 flex-fill">
          <span className="avatar avatar-lg bg-primary-transparent rounded me-2 flex-shrink-0 text-primary">
            <i className="ti ti-user-check fs-24" />
          </span>
          <div className="ms-2">
            <p className="mb-1">Present</p>
            <h5>{attendanceTotals.present}</h5>
          </div>
        </div>
      </div>

      {/* Absent */}
      <div className="col-md-6 col-xxl-4 d-flex">
        <div className="d-flex align-items-center rounded border p-3 mb-3 flex-fill">
          <span className="avatar avatar-lg bg-danger-transparent rounded me-2 flex-shrink-0 text-danger">
            <i className="ti ti-user-x fs-24" />
          </span>
          <div className="ms-2">
            <p className="mb-1">Absent</p>
            <h5>{attendanceTotals.absent}</h5>
          </div>
        </div>
      </div>

      {/* Late */}
      <div className="col-md-6 col-xxl-4 d-flex">
        <div className="d-flex align-items-center rounded border p-3 mb-3 flex-fill">
          <span className="avatar avatar-lg bg-warning-transparent rounded me-2 flex-shrink-0 text-warning">
            <i className="ti ti-clock fs-24" />
          </span>
          <div className="ms-2">
            <p className="mb-1">Leave</p>
            <h5>{attendanceTotals.leave}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <div className="card">
      <div className="card-body p-0 py-3">
        <div className="px-3">
          <div className="d-flex align-items-center flex-wrap">
            <div className="d-flex align-items-center bg-white border rounded p-2 me-3 mb-3">
              <span className="avatar avatar-sm bg-success rounded me-2 flex-shrink-0 ">
                <i className="ti ti-checks" />
              </span>
              <p className="text-dark">Present</p>
            </div>
            <div className="d-flex align-items-center bg-white border rounded p-2 me-3 mb-3">
              <span className="avatar avatar-sm bg-danger rounded me-2 flex-shrink-0 ">
                <i className="ti ti-x" />
              </span>
              <p className="text-dark">Absent</p>
            </div>
            <div className="d-flex align-items-center bg-white border rounded p-2 me-3 mb-3">
              <span className="avatar avatar-sm bg-warning rounded me-2 flex-shrink-0 ">
                <i className="ti ti-clock-x" />
              </span>
              <p className="text-dark">Leave</p>
            </div>
          </div>
        </div>
        <div className="ant-table-wrapper table datanew dataTable no-footer css-dev-only-do-not-override-11mmrso">
          <div className="ant-spin-nested-loading css-dev-only-do-not-override-11mmrso">
            <div className="ant-spin-container">
              <div className="ant-table css-dev-only-do-not-override-11mmrso">
                <div className="ant-table-container">
                  <div className="ant-table-content">
  <table style={{ width: "100%" }}>
    <thead className="ant-table-thead">
      <tr>
        <th>Date | Month</th>
        {[
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ].map((month) => (
          <th key={month}>{month}</th>
        ))}
      </tr>
    </thead>

    <tbody className="ant-table-tbody">
      {sortedDays.map((day) => (
        <tr key={day}>
          <td>{day.padStart?.(2, "0") || day}</td>
          {[
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
          ].map((month) => (
            <td key={month}>
              {groupedData[day][month] ? (
                <span
                  className={`attendance-range ${getStatusClass(
                    groupedData[day][month]
                  )}`}
                />
              ) : (
                <span className="attendance-range bg-light" />
              )}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default AttendanceTransportHistory
